export default __webpack_public_path__ + "static/media/game.b4dd4cda.svg";